import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Linkedin = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 24 24"
      fill={fill}
      {...rest}
    >
      <g>
        <path d="M23 0H1a.945.945 0 0 0-1 1v22a.945.945 0 0 0 1 1h22a.945.945 0 0 0 1-1V1a.945.945 0 0 0-1-1zM7.1 20.5H3.6V9h3.6v11.5zM5.3 7.4a2.1 2.1 0 1 1 2.1-2.1 2.051 2.051 0 0 1-2.1 2.1zm15.2 13.1h-3.6v-5.6c0-1.3 0-3-1.8-3-1.9 0-2.1 1.4-2.1 2.9v5.7H9.4V9h3.4v1.6a3.717 3.717 0 0 1 3.4-1.8c3.6 0 4.3 2.4 4.3 5.5z" />
      </g>
    </svg>
  );
};

Linkedin.displayName = 'Linkedin';
